import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import { SITE_DATA_COOKIE_NAME } from "../../constants/app";
import isLocalStorageEnabled from "./isLocalStorageEnabled";
import LocalStorage from "./methods/localStorage";
import CookieStorage from "./methods/cookieStorage";
export var StorageWrapper = /*#__PURE__*/function () {
  function StorageWrapper() {
    _classCallCheck(this, StorageWrapper);
    var isLocalEnabled = isLocalStorageEnabled();
    this.storage = isLocalEnabled ? new LocalStorage() : new CookieStorage(SITE_DATA_COOKIE_NAME);
  }
  return _createClass(StorageWrapper, [{
    key: "get",
    value: function get(key) {
      return this.storage.get(key);
    }
  }, {
    key: "set",
    value: function set(key, item) {
      return this.storage.set(key, item);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      return this.storage.remove(key);
    }
  }]);
}();
export default new StorageWrapper();